interface ConFacilityDetailOrder {
  [key: string]: number;
}
interface CounselDesignItemCategory {
  [key: string]: string;
}

export const conFacilityDetailOrder: ConFacilityDetailOrder = {
  "건축 시설": 0,
  "추가 시설": 1,
  "환기 설비": 2,
  "관수 설비": 3,
  "양액 설비": 4,
  "냉난방 설비": 5,
  "환경 설비": 6,
  "기타 설비": 7,
};

export const counselDesignItemCategory1: CounselDesignItemCategory = {
  A: "건축 시설",
  B: "추가 시설",
  C: "환기 설비",
  D: "관수 설비",
  E: "양액 설비",
  F: "냉난방 설비",
  G: "환경 설비",
  Z: "기타 설비",
};

export const counselDesignItemCategory2: CounselDesignItemCategory = {
  "001": "기초",
  "002": "골조",
  "003": "피복",
  "004": "개폐",
  "005": "수평 커튼",
  "006": "천창개폐(몽골)",
  "007": "외부 배기",
  "008": "내부 환기",
  "009": "샷시 창문",
  "010": "포그 관수",
  "011": "스프링클러 관수",
  "012": "점적 관수",
  "013": "수막 관수",
  "014": "고형배지 양액 설비",
  "015": "NFT 양액 설비",
  "016": "온수 난방",
  "017": "증기 난방",
  "018": "온풍 난방",
  "019": "직열튜브 난방",
  "020": "지열히트펌프",
  "021": "물탱크 칠러",
  "022": "에어컨",
  "023": "복합환경제어 설비",
  "024": "CO2 설비",
  "025": "자동 방제기",
  "026": "작업부/작업동",
  "027": "선반/균상다이",
  "028": "운반 레일",
  "029": "지반평탄화/배수로",
  "030": "바닥 콘크리트",
  "031": "화장실/정화조/관정",
  "032": "컨테이너",
};
